<template>
  <div class="package-content-slider">
    <flickity
      class="slides"
      ref="flickity"
      :options="flickityOptions"
    >
      <Slide
        v-for="(slide, index) in slides"
        :key="index"
        v-bind="slide"
        :active="index === activeSlideIndex"
      />
    </flickity>
  </div>
</template>

<script>
import Flickity from 'vue-flickity'
import { ClothingIcon, ToysIcon, GlasswareIcon, LightningIcon, KitchenIcon, SmallIcon, GroceriesIcon } from './icons'
import Slide from './Slide'

export default {
  name: 'PackageContentSlider',
  data () {
    return {
      flickityOptions: {
        prevNextButtons: false,
        pageDots: true,
        wrapAround: false,
        dragThreshold: 10
      },
      activeSlideIndex: 0,
      slides: [{
        icon: ClothingIcon,
        category: 'Kleding',
        percentage: 18
      }, {
        icon: ToysIcon,
        category: 'Speelgoed',
        percentage: 52
      }, {
        icon: GlasswareIcon,
        category: 'Glazen',
        percentage: 64
      }, {
        icon: LightningIcon,
        category: 'Licht en lampen',
        percentage: 43
      }, {
        icon: KitchenIcon,
        category: 'Keukenspullen',
        percentage: 50
      }, {
        icon: SmallIcon,
        category: 'Kleine keukenapparatuur',
        percentage: 40
      }, {
        icon: GroceriesIcon,
        category: 'Boodschappen',
        percentage: 51
      }]
    }
  },
  components: {
    Flickity,
    Slide
  },
  mounted () {
    this.$refs.flickity.on('change', index => {
      this.activeSlideIndex = index
    })
  }
}
</script>

<style lang="scss" scoped>
.package-content-slider {
  margin: 2em auto;
  position: relative;
}

.slides {
  outline: 0;
}

.is-selected {
  opacity: 1;
  transform: scale(1);
}
</style>
<style lang="scss">
.package-content-slider {
  .flickity-page-dots {
    position: static;
    bottom: 0;
    margin-top: 31px;
    font-size: 0;

    .dot {
      background-color: rgba(0, 0, 0, 0.2);
      opacity: 1;
      width: 13px;
      height: 13px;
      margin: 0 5px;
      will-change: opacity;
      transition: opacity 200ms ease;
      position: relative;

      &:hover {
        opacity: 0.8;
      }

      &::after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: $c-red;
        transform: scale(0);
        z-index: 1;
        transition: transform 400ms ease;
        will-change: transform;
        border-radius: 50%;
      }

      &.is-selected::after {
        transform: scale(1);
      }
    }
  }
}
</style>
